// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LsEC","content":"styles_content__3zEAr","row":"styles_row__3bkob","footer":"styles_footer__1QWii","phraseLength":"styles_phraseLength__1uJKt"};